import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import pt from 'vuetify/es5/locale/pt'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  lang: {
    locales: { pt },
    current: 'pt'
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#118799',
        secondary: '#A0C03A',
        accent: '#00aeb7',
        error: '#DC222B',
        advice: '#f57d7d',
        info: '#1BA9DF',
        success: '#1A984C',
        warning: '#FFB800',
        cautious: '#FF6600',
        neutral: '#B8B8B8',
        lightgray: '#efefef',
        border_gray: '#bbb',
        white: '#fff',
        gray: '#d5d5d5',
        darkgray: '#a5a5a5',
        dark: '#707070',
        darkwhite: '#F7F7F7',
        advice_friendly: '#1C1C1C',
        advice_friendly_text: '#333',
        default_primary_color: '#0B475E',
        default_secodary_color: '#1BA9DF',
        default_accent_color: '#5FBEE3'
      }
    }
  }
})
